<mat-form-field class="time-field">
	@if (label) {
	<mat-label>{{ label }}</mat-label>
	}
	<input
		matInput
		[value]="value"
		(input)="onInput($any($event.target).value)"
		(blur)="onBlur()"
		[disabled]="disabled"
		placeholder="ЧЧ:мм"
		inputmode="numeric" />
	<button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="menu" [disabled]="disabled" tabindex="-1">
		<mat-icon>schedule</mat-icon>
	</button>
	<mat-menu #menu="matMenu" class="time-field-menu">
		@for (option of quickOptions; track option) {
		<button mat-menu-item (click)="select(option)">{{ option }}</button>
		}
	</mat-menu>
</mat-form-field>
